import { proxy } from 'valtio'
import {
  ChinaRankingCategory,
  CommonApi,
  KuRelationshipType,
  SecurityExportControlType,
} from '../../generated'
import { apiConfig } from '../apiConfig'

interface MasterTypeStore {
  securityExportControlTypes: SecurityExportControlType[]
  kuRelationshipTypes: KuRelationshipType[]
  chinaRankingCategories: ChinaRankingCategory[]
}

export const masterTypeStore = proxy<MasterTypeStore>({
  securityExportControlTypes: [],
  kuRelationshipTypes: [],
  chinaRankingCategories: [],
})

const api = new CommonApi(apiConfig)

export async function loadMasterTypes() {
  const [sec, ku, china] = await Promise.all([
    api.getSecurityExportControlTypes(),
    api.getKuRelationshipTypes(),
    api.getChinaRankingCategories(),
  ])
  masterTypeStore.securityExportControlTypes = sec
  masterTypeStore.kuRelationshipTypes = ku
  masterTypeStore.chinaRankingCategories = china
}

export function getSecurityExportControlType(id?: number | null): SecurityExportControlType | null {
  if (id == null) return null
  return masterTypeStore.securityExportControlTypes.find((t) => t.id === id) ?? null
}

export function getKuRelationshipType(id?: number | null): KuRelationshipType | null {
  if (id == null) return null
  return masterTypeStore.kuRelationshipTypes.find((t) => t.id === id) ?? null
}

export function getChinaRankingCategory(id?: number | null): ChinaRankingCategory | null {
  if (id == null) return null
  return masterTypeStore.chinaRankingCategories.find((t) => t.id === id) ?? null
}
